<template>
  <div class="relative bg-white overflow-hidden h-full">
    <div class="max-w-7xl mx-auto">
      <div class="relative z-10 pb-8 pt-16 bg-white sm:pb-16 md:pb-20 lg:max-w-xl lg:w-full lg:pb-28 xl:pb-32">
        <svg
          class="hidden lg:block absolute right-0 inset-y-0 h-full w-80 text-white transform translate-x-1/2"
          fill="currentColor"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <polygon points="30,0 100,0 70,100 30,100" />
        </svg>
        <main class="mx-auto max-w-7xl px-4 sm:mt-8 sm:px-6 md:mt-4 lg:mt-14 lg:px-8 xl:mt-14">
          <div class="sm:text-center lg:text-left">
            <div class="mx-auto p-2 rounded-md shadow-lg w-full max-w-sm lg:w-96">
              <div>
                <h2 class="text-3xl leading-9 font-extrabold text-gray-900">
                  Sign in to your account
                </h2>
                <p class="mt-2 text-sm text-gray-600 max-w">
                  Or
                  <a
                    :href="route('register')"
                    class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                  >
                    start your 14-day free trial
                  </a>
                </p>
              </div>

              <div class="mt-8">
                <hr>
                <div class="mt-6">
                  <form @submit.prevent="submit">
                    <div>
                      <jet-label
                        for="email"
                        value="Email"
                      />
                      <jet-input
                        id="email"
                        v-model="form.email"
                        type="email"
                        class="mt-1 block w-full"
                        required
                        autofocus
                      />
                      <p
                        v-if="form.errors.email"
                        id="name-error"
                        class="mt-2 text-sm text-red-600"
                      >
                        {{ form.errors.email }}
                      </p>
                    </div>

                    <div class="mt-4">
                      <jet-label
                        for="password"
                        value="Password"
                      />
                      <jet-input
                        id="password"
                        v-model="form.password"
                        type="password"
                        class="mt-1 block w-full"
                        required
                        autocomplete="current-password"
                      />
                    </div>

                    <div class="flex items-center justify-between mt-4">
                      <div class="flex items-center">
                        <label class="flex items-center">
                          <jet-checkbox
                            v-model:checked="form.remember"
                            name="remember" />
                          <span class="ml-2 block text-sm text-gray-900">Remember me</span>
                        </label>
                      </div>

                      <div class="text">
                        <Link
                          v-if="canResetPassword"
                          :href="route('password.request')"
                          class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                        >
                          Forgot
                          your
                          password?
                        </Link>
                      </div>
                    </div>

                    <div class="flex items-center justify-end mt-4">
                      <form-button
                        :class="{ 'opacity-25': form.processing }"
                        :disabled="form.processing"
                      >
                        Sign in
                      </form-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
    <div class="lg:absolute lg:inset-y-1 lg:right-0 lg:w-1/2">
      <img
        class="h-56 w-full object-cover sm:h-72 md:h-96 lg:w-full lg:h-full"
        src="https://images.unsplash.com/photo-1485217988980-11786ced9454?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2850&q=80"
        alt=""
      >
    </div>
  </div>

<!--    <div class="relative bg-gradient-to-r from-gray-600 to-indigo-700">-->
<!--        <div class="relative h-56 w-96 bg-indigo-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">-->
<!--            <img class="w-full h-full object-cover" src="https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&sat=-100" alt="">-->
<!--            <div aria-hidden="true" class="absolute inset-0 bg-gradient-to-r from-teal-500 to-cyan-600 mix-blend-multiply"></div>-->
<!--        </div>-->
<!--        <div class="relative mx-auto max-w-md px-4 py-12 sm:max-w-7xl sm:px-6 sm:py-20 md:py-28 lg:px-8 lg:py-32">-->
<!--            <div class="md:ml-auto md:w-1/2 md:pl-10">-->
<!--                <h2 class="text-base font-semibold uppercase tracking-wider text-gray-300">-->
<!--                    Award winning support-->
<!--                </h2>-->
<!--                <p class="mt-2 text-white text-3xl font-extrabold tracking-tight sm:text-4xl">-->
<!--                    We’re here to help-->
<!--                </p>-->
<!--                <p class="mt-3 text-lg text-gray-300">-->
<!--                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et, egestas tempus tellus etiam sed. Quam a scelerisque amet ullamcorper eu enim et fermentum, augue. Aliquet amet volutpat quisque ut interdum tincidunt duis.-->
<!--                </p>-->
<!--                <div class="mt-8">-->
<!--                    <div class="inline-flex rounded-md shadow">-->
<!--                        <a :href="route('operators')" target="_blank" class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-gray-900 bg-white hover:bg-gray-50">-->
<!--                            Visit the help center-->
<!--                            &lt;!&ndash; Heroicon name: solid/external-link &ndash;&gt;-->
<!--                            <svg class="-mr-1 ml-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">-->
<!--                                <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />-->
<!--                                <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />-->
<!--                            </svg>-->
<!--                        </a>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
</template>

<script>
// import AuthLayout from "../../Layouts/AuthLayout";
import FormButton from '../../ComponentsDeprecated/Button.vue';
import JetInput from '../../Jetstream/Input.vue';
import JetCheckbox from '../../Jetstream/Checkbox.vue';
import JetLabel from '../../Jetstream/Label.vue';
import LandingLayout from '../../Layouts/LandingLayout.vue';
import {Link} from '@inertiajs/vue3'

export default {
  components: {
    // AuthLayout,
    FormButton,
    JetInput,
    JetCheckbox,
    JetLabel,
      Link,
  },
  layout: LandingLayout,
  props: {
    canResetPassword: Boolean,
    status: String,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: true,
      }),
    };
  },

  methods: {
    submit() {
      this.form
        .transform((data) => ({
          ...data,
          remember: this.form.remember ? 'on' : '',
        }))
        .post(this.route('login'), {
          onFinish: () => this.form.reset('password'),
        });
    },
  },
};
</script>
